const experience = [
    {
        title: "Judiciary Software Engineer",
        company: "Supreme Court of Barbados",
        startDate: "September 2025",
        endDate: "Present",
        location: "Remote",
        logo: "assets/logos/supreme-court-barbados.jpg",
    },
    {
        title: "Machine Learning Fellow",
        company: "FluoretiQ",
        startDate: "July 2025",
        endDate: "August 2025",
        location: "Bristol, UK",
        logo: "assets/logos/fluoretiq.jpeg",
    },
    {
        title: "Software Engineer",
        company: "District 6 Technologies",
        startDate: "Sep 2024",
        endDate: "May 2025",
        location: "Remote",
        logo: "assets/logos/d6.jpg",
    },
    {
        title: "Software Developer",
        company: "Pellucid IT",
        startDate: "Jul 2024",
        endDate: "Jan 2025",
        location: "Remote",
        logo: "assets/logos/pellucid.png",
    },
    {
        title: "Software Developer Intern",
        company: "Pellucid IT",
        startDate: "Jan 2024",
        endDate: "Jul 2024",
        location: "Remote",
        logo: "assets/logos/pellucid.png",
    },
    {
        title: "Judiciary Software Engineer",
        company: "National Center for State Courts",
        startDate: "Jul 2023",
        endDate: "Aug 2023",
        location: "Remote",
        logo: "assets/logos/ncsc.jpg",
    },
    {
        title: "Digital Transformation Intern",
        company: "Central Bank of Barbados",
        startDate: "Jun 2023",
        endDate: "Jul 2023",
        location: "Barbados",
        logo: "assets/logos/cbb.png",
    },
]

export default experience